import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js/pure";
import { Link, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PageSEO from 'components/Utlility/PageSEO';
import { SEO_CONFIG } from 'constants/SeoConfig'
import { Elements, } from "@stripe/react-stripe-js";
import StripeService from "../services/stripe.service";
import { increaseQuantity, lowerQuantity, removeFromCart, addMultipleToCart } from "actions/cart";
import Spinner from 'react-bootstrap/Spinner';
import { FaPlus, FaMinus } from 'react-icons/fa';
import Analytics from "analytics";
import ErrorModal from '../components/Utlility/ErrorModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import DotLoader from 'components/Utlility/DotLoader';
import { getCookie } from 'helpers/cookies';

import TrustBoxContainer, { TRUSTPILOT_TEMPLATES } from './TrustWidget';

import CheckoutForm from "./Forms/CheckoutForm";
import FormPage from "./Forms/FormPage";
import { Container, Row, Form, Alert } from "react-bootstrap";
import styles from "./CheckoutStyles.module.scss";
// import styles from "./Forms/FormStyles.module.scss";
import bin from "images/icons/bin.png"
import pineapplePalm from "images/heros/Summer Sale/summer-pineapple-palm.png";
import pineapplePalm2x from "images/heros/Summer Sale/summer-pineapple-palm@2x.png";
import SummerSaleBannerSlot from "./Heros/SummerSale/SummerSaleBannerSlot";
import { isSummerSaleActive, SUMMER_SALE } from "constants/SummerSale";
import Game from "./Games/Game";
import { getGameList, findGameById } from "../constants/GameListAdapter";
import pricing from "../reducers/pricing";
import PricingFunctions from "../common/PricingFunctions";

import UpsellModal from "components/Modals/UpsellModal/UpsellModal";
import {
    AUTO_DISCOUNT_PERCENT as FALLBACK_AUTO_DISCOUNT_PERCENT,
    AUTO_DISCOUNT_MIN_GAMES as FALLBACK_AUTO_DISCOUNT_MIN_GAMES,
} from "constants/DiscountConfig";
import { promoConfig } from "services/promoConfig";

export default function Checkout() {
    // Auto-discount values come from the active promo campaign (falling back to the
    // constants if the config is unavailable), so the displayed discount and the
    // autoDiscountPercent sent to the payment intent match what the homepage shows.
    // NOTE: the server independently re-resolves/validates this percent (Phase 3).
    // discountPercent is null when the active campaign grants no discount
    // (promoConfig mirrors the server rule) — 0 here disables all
    // auto-discount UI and maths rather than advertising 0% off.
    const _promo = promoConfig.getConfig();
    const AUTO_DISCOUNT_PERCENT = _promo.discountPercent > 0 ? _promo.discountPercent : 0;
    const AUTO_DISCOUNT_MIN_GAMES = _promo.minGames ?? FALLBACK_AUTO_DISCOUNT_MIN_GAMES;

    const [searchParams, setSearchParams] = useSearchParams();
    const [hasProcessedUrl, setHasProcessedUrl] = useState(false);
    const [clientSecret, setClientSecret] = useState("");
    const [checkoutStep, setCheckoutStep] = useState(false);
    const [checkoutItems, setCheckoutItems] = useState([]);
    const [currency, setCurrency] = useState("");
    const [loadingCheckout, setLoadingCheckout] = useState(false);
    const [cartTotal, setCartTotal] = useState(0);
    const [checkoutTotal, setCheckoutTotal] = useState(0);
    const [checkoutSavingsTotal, setCheckoutSavingsTotal] = useState(0);
    const [rewardDiscountInitilised, setRewardDiscountInitilised] = useState(false);
    const [stripePromise, setStripePromise] = useState(null);

    const [promoCode, setPromoCode] = useState("");
    const [promoBoxOpen, setPromoBoxOpen] = useState(true);
    const [checkingPromoCode, setCheckingPromoCode] = useState(false);
    const [promoCodeApplied, setPromoCodeApplied] = useState(false);
    const [promoCodeMessageFromStripe, setPromoCodeMessageFromStripe] = useState("");
    const [promoCodeMessage, setPromoCodeMessage] = useState("");
    const [promoCodePercentage, setPromoCodePercentage] = useState("");
    const [discount, setDiscount] = useState("");
    const [discountProducts, setDiscountProducts] = useState(null);
    const [promoApplicableProductIds, setPromoApplicableProductIds] = useState([]);
    const [email, setEmail] = useState("");
    const [showAgeWarning, setShowAgeWarning] = useState(false);
    const [firstName, setFirstName] = useState("");

    const [showUpsell, setShowUpsell] = useState(false);
    const [upsellItem, setUpsellItem] = useState(null);
    const [checkoutError, setCheckoutError] = useState(null);

    const [autoDiscountActive, setAutoDiscountActive] = useState(false);

    const { items } = useSelector(state => state.cart);
    const { isLoggedIn, user } = useSelector(state => state.auth);
    const { countryCode, } = useSelector(state => state.pricing);
    const { discountCode, } = useSelector(state => state.discount);
    const dispatch = useDispatch();


    useEffect(() => {
        if (hasProcessedUrl) return;

        const gameIds = searchParams.get('add');

        if (!gameIds) {
            setHasProcessedUrl(true);
            return;
        }

        const idsToAdd = gameIds.split(',').map(id => id.trim());
        const existingIds = new Set(items.map(item => item.id));

        const gamesToAdd = idsToAdd
            .filter(gameId => !existingIds.has(gameId))
            .map(gameId => getGameList().find(g => g.gameId === gameId && g.status === "enabled"))
            .filter(Boolean);

        if (gamesToAdd.length) {
            dispatch(addMultipleToCart(gamesToAdd));
        }

        searchParams.delete('add');
        setSearchParams(searchParams, { replace: true });
        setHasProcessedUrl(true);
    }, [items, hasProcessedUrl]);

    useEffect(() => {
        let amount = 0;
        let savings = 0;

        items.forEach((item) => {
            amount += Number(getNumericPrice(item));
        });

        // Auto-discount: 15% off for 3+ games. Addons don't count toward the
        // threshold (a single addon-only cart shouldn't unlock the discount), but
        // when the threshold IS hit the Stripe coupon still applies percent-off to
        // every line item — addons included.
        const totalUnits = items
            .filter(item => item.type !== 'Addon')
            .reduce((sum, item) => sum + (item.quantity || 1), 0);
        // During the Summer Sale, prices are already cut in Stripe — don't stack
        // the automatic 3+ games discount on top, and don't compute a 15% savings
        // line (it would show a total lower than what Stripe actually charges).
        // The sale itself is surfaced separately via the Summer Sale rewards box.
        // (Promo codes still apply.)
        const eligible = AUTO_DISCOUNT_PERCENT > 0 && totalUnits >= AUTO_DISCOUNT_MIN_GAMES && !isSummerSaleActive();
        setAutoDiscountActive(eligible);

        // Determine if promo code is better than auto-discount
        const promoIsBetterThanAuto = promoCodeApplied && promoCodePercentage > AUTO_DISCOUNT_PERCENT;

        if (promoCodeApplied) {
            if (eligible && !promoIsBetterThanAuto) {
                // Auto-discount is better — use it, show message about promo being lower
                savings = Number((amount / 100) * AUTO_DISCOUNT_PERCENT).toFixed(2);
                setPromoCodeMessage(`Your code offers ${promoCodePercentage}% off, but you're already getting ${AUTO_DISCOUNT_PERCENT}% off with ${AUTO_DISCOUNT_MIN_GAMES}+ games!`);
            } else {
                // Promo code is better (or no auto-discount eligible)
                let discountableAmount = amount;
                if (promoApplicableProductIds.length > 0) {
                    const applicableItems = items.filter((item) => promoApplicableProductIds.includes(item.productId));
                    if (applicableItems.length === 0) {
                        setPromoCodeApplied(false);
                        setPromoCodePercentage("");
                        setPromoApplicableProductIds([]);
                        setPromoCodeMessage("Promo code removed — none of the applicable products are in your cart.");
                        setPromoCodeMessageFromStripe("");
                    } else {
                        discountableAmount = 0;
                        applicableItems.forEach((item) => {
                            discountableAmount += Number(getNumericPrice(item));
                        });
                        savings = Number((discountableAmount / 100) * promoCodePercentage).toFixed(2);
                        setPromoCodeMessage(`${promoCodePercentage}% off applied to: ${applicableItems.map((item) => item.name).join(", ")}. Discount will be applied at checkout.`);
                    }
                } else {
                    savings = Number((discountableAmount / 100) * promoCodePercentage).toFixed(2);
                    if (promoCodeMessageFromStripe !== "" && promoCodeMessageFromStripe !== null) {
                        setPromoCodeMessage(promoCodeMessageFromStripe);
                    } else {
                        setPromoCodeMessage("Promo code will be applied at checkout.");
                    }
                }
            }
        } else if (eligible) {
            // No promo code, but auto-discount applies
            savings = Number((amount / 100) * AUTO_DISCOUNT_PERCENT).toFixed(2);
        }

        setRewardDiscountInitilised(true);
        setCheckoutSavingsTotal(savings);
        setCheckoutTotal(amount);

    }, [discountCode, promoCodeApplied, promoCodePercentage, promoApplicableProductIds, JSON.stringify(items.map(i => i.quantity))]);


    useEffect(() => {
        if (!rewardDiscountInitilised) return;
        setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_KEY));
        console.log("Looking for discount in redux");
        console.log("Items : ", items);
        if (isLoggedIn) {
            setEmail(user.email);
        }

        if (discountCode != null) {
            console.log("Found it : ", discountCode);
            setPromoCode(discountCode);
            setPromoBoxOpen(true);
            //setPromoCodeMessage(`The code ${discountCode} has been applied to your cart!`);
            //setPromoCodeApplied(true);

            checkPromotionCode(null, discountCode);
        }
    }, [discountCode, rewardDiscountInitilised]);

    const appearance = {
        theme: 'flat',
        variables: {

        }
    };
    const options = {
        clientSecret,
        appearance,
        loader: "auto"
    };

    const addQuantity = (item) => {
        if (loadingCheckout) return;
        dispatch(increaseQuantity(item));
    }
    const minusQuantity = (item) => {
        if (loadingCheckout) return;
        dispatch(lowerQuantity(item));
    }
    const removeItem = (item) => {
        if (loadingCheckout) return;
        dispatch(removeFromCart(item));
    }

    const checkAgeRestriction = (e) => {
        e.preventDefault();
        if (items.find(i => i.minAge >= 17)) {
            setShowAgeWarning(true);
        }
        else continueToCheckout();
    }

    const cancelAgeWarning = () => {
        setShowAgeWarning(false);
    }

    const acceptAgeWarning = () => {
        setShowAgeWarning(false);
        continueToCheckout();
    }

    const getUpsellItem = () => {
        // Collect all item IDs we already have
        const existingIds = new Set(items.map(item => item.id));
        console.log("Existing Ids : ", existingIds);
        // Collect all upsell IDs from items
        let possibleIds = [];
        for (let item of items) {
            if (item.upsellIds != null) possibleIds.push(...item.upsellIds);
        }
        console.log("Possible Ids : ", possibleIds);

        // Filter out ones already in items
        possibleIds = possibleIds.filter(id => !existingIds.has(id));
        console.log("Possible Ids 2: ", possibleIds);

        if (possibleIds.length === 0) return null;


        // If logged in, filter out games already owned by user
        if (isLoggedIn && user?.games) {
            console.log("Is logged in");
            console.log("user games: ", user.games);
            const ownedCodes = new Set(user.games.map(g => g.code));
            console.log("owned codes: ", ownedCodes);
            possibleIds = possibleIds.filter(id => !ownedCodes.has(id));
        }

        console.log("Possible Ids 3: ", possibleIds);
        if (possibleIds.length === 0) return null;

        // Convert to actual game objects
        let possibleGames = getGameList().filter(game => possibleIds.includes(game.gameId));
        console.log("Possible games: ", possibleGames);


        if (possibleGames.length === 0) return null;

        // Pick a random game
        return possibleGames[Math.floor(Math.random() * possibleGames.length)];
    }


    const continueToCheckout = (skipUpsell = true) => {
        setLoadingCheckout(true);

        if (!skipUpsell) {
            const upsellItem = getUpsellItem();
            if (upsellItem) {
                setUpsellItem(upsellItem);
                setShowUpsell(true)
                    ; return;
            }
        }

        console.log("Upsell Item : ", upsellItem);
        console.log(items)

        const promoIsBetterThanAuto = promoCodeApplied && promoCodePercentage > AUTO_DISCOUNT_PERCENT;
        const useAutoDiscount = autoDiscountActive && !promoIsBetterThanAuto;
        var coupon = (!useAutoDiscount && promoCodeApplied) ? promoCode : null;
        const autoDiscountPercent = useAutoDiscount ? AUTO_DISCOUNT_PERCENT : null;
        console.log(promoCodeApplied, promoCode, coupon, autoDiscountPercent)
        const currency = PricingFunctions.getCurrency(countryCode);
        const source = getCookie("purchase_src");
        StripeService.createPaymentIntent(items, coupon, email, firstName, currency, countryCode, source, null, autoDiscountPercent)
            .then((res) => {
                setLoadingCheckout(false);
                setCheckoutStep(true);
                console.log("res data ", res.data);
                setCartTotal(res.data.cartTotal);
                setClientSecret(res.data.clientSecret)
                setCheckoutItems(res.data.checkoutItems);
                setCurrency(res.data.currency);
                if (res.data.discountPercentage) {
                    setDiscount(`-${res.data.discountPercentage}%`);
                    setDiscountProducts(res.data.applicableProducts);
                }
                Analytics.beginCheckout(items, currency, res.data.cartTotalRaw, coupon);
            }).catch((err) => {
                console.error("Checkout Error:", err);
                console.error("Error response:", err.response?.data);
                setLoadingCheckout(false);
                // Extract error message from various response formats
                let errorMessage = "There was an error processing your checkout. Please try again.";
                if (err.response?.data?.message) {
                    errorMessage = err.response.data.message;
                } else if (err.response?.data?.Message) {
                    errorMessage = err.response.data.Message;
                } else if (typeof err.response?.data === 'string') {
                    errorMessage = err.response.data;
                } else if (err.message) {
                    errorMessage = err.message;
                }
                setCheckoutError(errorMessage);
            });
    }

    const dismissCheckoutError = () => {
        setCheckoutError(null);
    }

    const onChangeCode = (e) => {
        if (!checkingPromoCode && !promoCodeApplied) {
            const code = e.target.value.toUpperCase();
            setPromoCode(code);
        }
    };

    const onChangeEmail = (e) => {
        const email = e.target.value;

        setEmail(email);
    };

    const onChangeFirstName = (e) => {
        const firstName = e.target.value;
        localStorage.setItem("FirstName", firstName);
        setFirstName(firstName);
    }

    const checkPromotionCode = (e, force = null) => {
        if (e) e.preventDefault();
        let promoCodeToCheck = force || promoCode;
        console.log("promo code : ", promoCodeToCheck);
        console.log("promo code length : ", promoCodeToCheck.length)
        console.log("checking promo code : ", checkingPromoCode);
        if (promoCodeToCheck.length > 0 && !checkingPromoCode) {
            setCheckingPromoCode(true);
            setPromoCodeMessage("");
            const productIds = items.map((x) => x.productId);
            console.log("*** Checking Promo Code ***");
            StripeService.checkPromotionCode(promoCodeToCheck, productIds)
                .then((res) => {
                    console.log("Check promo code res: ", res);
                    if (res.data.valid === true) {
                        setPromoApplicableProductIds(res.data.applicableProductIds || []);
                        setPromoCodeApplied(true);
                        setPromoCodePercentage(res.data.percentOff);

                        if (autoDiscountActive && res.data.percentOff <= AUTO_DISCOUNT_PERCENT) {
                            setPromoCodeMessage(`Code "${promoCodeToCheck}" offers ${res.data.percentOff}% off, but you're already getting ${AUTO_DISCOUNT_PERCENT}% off with ${AUTO_DISCOUNT_MIN_GAMES}+ games!`);
                            setPromoCodeMessageFromStripe(res.data.message);
                        } else {
                            setPromoCodeMessage(res.data.message);
                            setPromoCodeMessageFromStripe(res.data.message);
                        }
                    } else {
                        if (res.data.applicableProductIds && res.data.applicableProductIds.length > 0) {
                            const applicableProducts = getGameList().filter((x) => res.data.applicableProductIds.includes(x.productId));
                            const applicableProductNames = applicableProducts.map((x) => x.name);

                            setPromoCodeMessage(res.data.message + applicableProductNames.join(", ") + ".");
                            setPromoCodeMessageFromStripe(res.data.message + applicableProductNames.join(", ") + ".");
                        } else {
                            setPromoCodeMessage(res.data.message);
                            setPromoCodeMessageFromStripe(res.data.message);
                        }
                    }
                    setCheckingPromoCode(false);
                }).catch((err) => {
                    console.log("Check promo code err: ", err);
                    setPromoCodeApplied(false);
                    setCheckingPromoCode(false);
                    setPromoCodeMessage(err.message);
                    setPromoCodeMessageFromStripe(err.message);
                });
        }
    }

    const getPrice = (item) => {
        if (checkoutStep) {
            let checkoutItem = checkoutItems.find(x => x.productId === item.productId);
            if (!checkoutItem) {
                console.error(`Checkout item not found for productId: ${item.productId}`);
                return `${PricingFunctions.getCurrencySymbol(countryCode)}0.00`;
            }
            let actualAmount = (checkoutItem.total || 0) - (checkoutItem.discountAmount || 0);
            return `${PricingFunctions.getCurrencySymbol(countryCode)}${(actualAmount / 100).toFixed(2)}`;
        } else {
            // Look up by productId first, then by gameId (cart stores as 'id')
            let game = getGameList().find((x) => x.productId === item.productId || x.gameId === item.id);
            let pricing = PricingFunctions.getCartEffectiveGamePricing(countryCode, game, items, getGameList());
            let rawPrice = pricing?.raw || 0;
            return `${PricingFunctions.getCurrencySymbol(countryCode)}${(rawPrice * item.quantity).toFixed(2)}`;
        }
    }

    const getOriginalPrice = (item) => {
        let game = getGameList().find((x) => x.productId === item.productId || x.gameId === item.id);
        let pricing = PricingFunctions.getGamePricing(countryCode, game);
        return `${PricingFunctions.getCurrencySymbol(countryCode)}${(pricing?.raw * item.quantity).toFixed(2)}`;
    }

    // Sale "old price" strikethrough — mirrors the shop card / game detail page,
    // which read game.oldPricing via getGamePricing(..., true). Returns the line
    // total at the old price, or null if the game has no old price set.
    const getSaleStrikePrice = (item) => {
        let game = getGameList().find((x) => x.productId === item.productId || x.gameId === item.id);
        let oldPricing = PricingFunctions.getGamePricing(countryCode, game, true);
        if (!oldPricing || !oldPricing.raw || oldPricing.raw <= 0) return null;
        return `${PricingFunctions.getCurrencySymbol(countryCode)}${(oldPricing.raw * item.quantity).toFixed(2)}`;
    }

    // Aggregate sale discount across the cart, for the "(X% off)" label on the
    // total line. Compares each line's old price (game.oldPricing) against its
    // current effective price; returns null when nothing is on sale.
    const getSaleDiscountPercent = () => {
        let oldTotal = 0;
        let curTotal = 0;
        let hasSale = false;
        items.forEach((item) => {
            let game = getGameList().find((x) => x.productId === item.productId || x.gameId === item.id);
            let cur = PricingFunctions.getCartEffectiveGamePricing(countryCode, game, items, getGameList());
            let curRaw = cur?.raw || 0;
            let oldPricing = PricingFunctions.getGamePricing(countryCode, game, true);
            let oldRaw = (oldPricing && oldPricing.raw > curRaw) ? oldPricing.raw : curRaw;
            if (oldRaw > curRaw) hasSale = true;
            oldTotal += oldRaw * item.quantity;
            curTotal += curRaw * item.quantity;
        });
        if (!hasSale || oldTotal <= 0 || curTotal >= oldTotal) return null;
        return Math.round((1 - curTotal / oldTotal) * 100);
    }

    const getItemCompanionDiscount = (item) => {
        let game = getGameList().find((x) => x.productId === item.productId || x.gameId === item.id);
        return PricingFunctions.getCartCompanionDiscount(game, items, getGameList());
    }

    const getItemOwnedDiscount = (item) => {
        let game = getGameList().find((x) => x.productId === item.productId || x.gameId === item.id);
        if (!PricingFunctions.hasCrossRegionDiscount(game)) return null;
        const discount = PricingFunctions.getCrossRegionDiscount(game);
        const offer = PricingFunctions.getCompanionOffer(game);
        // Calculate discounted qty: 1 owned + twin copies in cart
        let twinCartQty = 0;
        if (offer) {
            const twinCartItem = items.find(ci => {
                const cartGame = getGameList().find(g => g.productId === ci.productId || g.gameId === ci.id);
                return cartGame && (cartGame.gameId === offer.companionStoreGameId || cartGame.storeGameId === offer.companionStoreGameId);
            });
            twinCartQty = twinCartItem?.quantity || 0;
        }
        const totalTwinCopies = 1 + twinCartQty;
        const discountedQty = Math.min(item.quantity, totalTwinCopies);
        return { percent: discount.percent, ownedPackName: discount.ownedPackName, discountedQty };
    }

    const getNumericPrice = (item) => {
        if (checkoutStep) {
            let checkoutItem = checkoutItems.find(x => x.productId === item.productId);
            if (!checkoutItem) {
                console.error(`Checkout item not found for productId: ${item.productId}`);
                return "0.00";
            }
            let actualAmount = (checkoutItem.total || 0) - (checkoutItem.discountAmount || 0);
            return (actualAmount / 100).toFixed(2);
        } else {
            // Look up by productId first, then by gameId (cart stores as 'id')
            let game = getGameList().find((x) => x.productId === item.productId || x.gameId === item.id);
            let pricing = PricingFunctions.getCartEffectiveGamePricing(countryCode, game, items, getGameList());
            let rawPrice = pricing?.raw || 0;
            return (rawPrice * item.quantity).toFixed(2);
        }
    }

    const getStrikePrice = (item) => {
        let checkoutItem = checkoutItems.find(x => x.productId === item.productId);
        if (!checkoutItem) {
            return null;
        }
        if (checkoutItem.discountAmount) {
            let actualAmount = checkoutItem.total || 0;
            return `${PricingFunctions.getCurrencySymbol(countryCode)}${(actualAmount / 100).toFixed(2)}`;
        } else {
            return null;
        }
    }

    const upsellModalCallback = () => {
        setShowUpsell(false);
        continueToCheckout(true);
    }

    const isDev = () => { return !process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'development' }

    const getTotalSavings = () => {
        let amount = 0;
        checkoutItems.forEach((item) => {
            if (item.discountAmount) {
                amount += item.discountAmount;
            }
        });
        console.log(`total savings : ${amount}`)
        if (amount === 0) return null;
        else return `${PricingFunctions.getCurrencySymbol(countryCode)}${(amount / 100).toFixed(2)}`;
    }

    const togglePromoBoxOpen = (value) => {
        if (!checkingPromoCode) {
            setPromoBoxOpen(value);
        }
    }

    const renderItemList = (list, title) => {
        return <table className={styles.checkoutTable}>
            <tr>
                <th>{title}</th>
                <th>Quantity</th>
                <th>Price</th>
                {
                    (!checkoutStep || getTotalSavings() != null) &&
                    <th></th>
                }
            </tr>
            {
                list.map(item => {
                    return renderItemRow(item);
                })
            }
            {!checkoutStep && checkoutSavingsTotal > 0 &&
                <>
                    <tr className={styles.total}>
                        <td className={styles.buffer}></td>
                        <td className={styles.title}>Subtotal</td>
                        <td style={{ textDecoration: "line-through", color: "darkgray" }}>{PricingFunctions.getCurrencySymbol(countryCode)}{(checkoutTotal).toFixed(2)}</td>
                    </tr>
                    <tr className={styles.total}>
                        <td className={styles.buffer}></td>
                        <td className={styles.title}>{autoDiscountActive && !(promoCodeApplied && promoCodePercentage > AUTO_DISCOUNT_PERCENT) ? `${AUTO_DISCOUNT_PERCENT}% off` : 'YOUR PRICE!'}</td>
                        <td style={{ color: "#28a745", fontWeight: "bold" }}>{PricingFunctions.getCurrencySymbol(countryCode)}{(checkoutTotal - checkoutSavingsTotal).toFixed(2)}</td>
                    </tr>
                </>
            }
            {!checkoutStep && checkoutSavingsTotal <= 0 &&
                <tr className={styles.total}>
                    <td className={styles.buffer}></td>
                    <td className={styles.title}>Total</td>
                    <td>
                        {PricingFunctions.getCurrencySymbol(countryCode)}{(checkoutTotal).toFixed(2)}
                        {getSaleDiscountPercent() != null &&
                            <span style={{ color: "#28a745", fontSize: "0.8em", fontWeight: "normal", marginLeft: "0.5em" }}>{`(${getSaleDiscountPercent()}% off)`}</span>
                        }
                    </td>
                </tr>
            }
            {checkoutStep &&
                <>
                    <tr className={styles.total}>
                        <td className={styles.buffer}></td>
                        <td className={styles.title}>Total</td>
                        <td>
                            {cartTotal}
                            {getSaleDiscountPercent() != null &&
                                <span style={{ color: "#28a745", fontSize: "0.8em", fontWeight: "normal", marginLeft: "0.5em" }}>{`(${getSaleDiscountPercent()}% off)`}</span>
                            }
                        </td>
                    </tr>
                    {
                        getTotalSavings() != null &&
                        <tr className={styles.totalSavings}>
                            <td></td>
                            <td>Total Savings</td>
                            <td>{getTotalSavings()}</td>
                            <td className={styles.bufferSmall}></td>
                        </tr>
                    }
                </>
            }

        </table>
    }

    const renderRewardsBox = () => {

        let savings = checkoutSavingsTotal;
        const curr = PricingFunctions.getCurrencySymbol(countryCode);
        const promoIsBetterThanAuto = promoCodeApplied && promoCodePercentage > AUTO_DISCOUNT_PERCENT;

        // Check for Black Friday promo code FIRST (even before validation)
        if (promoCode === "FRIDAY50") {
            const assumedSavings = promoCodeApplied
                ? savings
                : (checkoutTotal * 0.5).toFixed(2);

            return <div className={`${styles.rewardsBox} ${styles.blackFriday}`} >
                <h2>BLACK FRIDAY DEAL!</h2>
                <h2>YOU'RE SAVING {curr}{assumedSavings}</h2>
                <Link to="/shop" className={styles.shopLink}>Continue Shopping</Link>
            </div>
        }

        // Promo code is better than auto-discount
        if (promoIsBetterThanAuto) {
            return <div className={styles.rewardsBox}>
                <h2>Wahoo... YOU'RE SAVING {curr}{savings}</h2>
                <p>Promo Code Applied - {promoCodePercentage}% Discount!</p>
                <Link to="/shop" className={styles.shopLink}>Continue Shopping</Link>
            </div>
        }

        // Summer Sale active — prices are already cut in Stripe, so we show the
        // sale's real headline percent here (the 15% auto-discount is suppressed
        // during the sale, so there's no separate savings line to reconcile).
        // Auto-discount active (non-sale) — same banner, 15% headline.
        if (isSummerSaleActive()) {
            return <div className={`${styles.rewardsBox} ${styles.summerSale}`}>
                <div className={styles.summerSaleText}>
                    <h2>You're getting {SUMMER_SALE.percent}% OFF!</h2>
                    <p>Game.City Summer Sale!</p>
                    <Link to="/shop" className={styles.shopLink}>Continue shopping</Link>
                </div>
                <img
                    src={pineapplePalm}
                    srcSet={`${pineapplePalm} 1x, ${pineapplePalm2x} 2x`}
                    className={styles.summerSalePineapple}
                    alt=""
                    aria-hidden="true"
                    draggable={false}
                />
                <div className={styles.summerSaleBars} aria-hidden="true">
                    <span /><span /><span /><span />
                </div>
            </div>
        }

        // Multi-buy auto-discount (outside the sale) — the standard rewards box,
        // not the summer-sale styling.
        if (autoDiscountActive) {
            return <div className={styles.rewardsBox}>
                <h2>You're getting {AUTO_DISCOUNT_PERCENT}% OFF!</h2>
                <p>Multi-buy discount applied to your whole order.</p>
                <Link to="/shop" className={styles.shopLink}>Continue shopping</Link>
            </div>
        }

        // Not enough games for auto-discount — nudge. Addons don't count.
        // Suppressed during the Summer Sale since the auto-discount is disabled,
        // and only on the cart (no point nudging on the payment step).
        const gameUnits = items
            .filter(item => item.type !== 'Addon')
            .reduce((sum, item) => sum + (item.quantity || 1), 0);
        if (!checkoutStep && !isSummerSaleActive() && AUTO_DISCOUNT_PERCENT > 0 && items.length > 0 && gameUnits < AUTO_DISCOUNT_MIN_GAMES) {
            const remaining = AUTO_DISCOUNT_MIN_GAMES - gameUnits;
            return <div className={styles.rewardsBox}>
                <h2>Nearly there!</h2>
                <p>Add <b>{remaining} more game{remaining > 1 ? 's' : ''}</b> to get <b>{AUTO_DISCOUNT_PERCENT}% off</b> your entire order!</p>
                <Link to="/shop" className={styles.shopLink}>Continue Shopping</Link>
            </div>
        }

        return null;
    }

    const renderCompanionDiscountBanner = () => {
        if (checkoutStep) return null;

        const discounts = [];
        items.forEach(item => {
            const od = getItemOwnedDiscount(item);
            if (od) {
                const isPartial = od.discountedQty < item.quantity;
                discounts.push({
                    name: item.name,
                    percent: od.percent,
                    reason: `you own ${od.ownedPackName}`,
                    partial: isPartial ? `${od.discountedQty} of ${item.quantity}` : null
                });
                return;
            }
            const cd = getItemCompanionDiscount(item);
            if (cd) {
                const isPartial = cd.discountedQty < item.quantity;
                discounts.push({
                    name: item.name,
                    percent: cd.discountPercent,
                    reason: `bought with ${cd.companionName}`,
                    partial: isPartial ? `${cd.discountedQty} of ${item.quantity}` : null
                });
            }
        });

        if (discounts.length === 0) return null;

        return (
            <div className={styles.companionBanner}>
                {discounts.map((d, i) => (
                    <p key={i}>
                        <strong>{d.percent}% off {d.name}</strong> — {d.reason}
                        {d.partial && ` (applied to ${d.partial})`}
                    </p>
                ))}
            </div>
        );
    }

    const renderItemRow = (item) => {
        return <tr>
            <td className={styles.itemName} >{item.name}</td>
            {
                checkoutStep ?
                    <>
                        <td>
                            <div className={styles.amountPicker}>
                                <div className={`${styles.quantity} ${checkoutStep && styles.checkoutStep}`}>{item.quantity}</div>
                            </div>
                        </td>
                        {/*<td><span style={{textDecoration: "line-through", color: "darkgray"}}>{getStrikePrice(item)}</span>{`${getPrice(item)} ${discountProducts != null && (discountProducts.includes(item.productId) || discountProducts.length == 0) ? discount : ""}` || <Spinner animation="border" size="sm" />}</td>*/}


                        <td>
                            {`${getPrice(item)}` || <DotLoader size="small" variant="dark" />}{` `}
                            {getSaleStrikePrice(item) &&
                                <span style={{ textDecoration: "line-through", color: "#c60d0d", fontSize: "0.8em", fontWeight: "normal", marginLeft: "0.5em" }}>{getSaleStrikePrice(item)}</span>
                            }
                        </td>
                        {
                            getStrikePrice(item) &&
                            <td>
                                <span style={{ textDecoration: "line-through", color: "darkgray" }}>{checkoutItems.find((x) => x.productId === item.productId).discountAmount && getStrikePrice(item)}</span>
                            </td>
                        }
                    </>
                    :
                    <>
                        <td>
                            <div className={styles.amountPicker}>
                                <div className={styles.quantity}>{item.quantity}
                                    <button className={styles.minus} onClick={() => minusQuantity(item)}>
                                        {'<'}
                                    </button>
                                    <button className={styles.add} onClick={() => addQuantity(item)}>
                                        {'>'}
                                    </button>
                                </div>
                            </div>
                        </td>
                        <td>
                            {promoCodeApplied && (promoApplicableProductIds.length === 0 || promoApplicableProductIds.includes(item.productId)) ?
                                <>
                                    <span style={{ textDecoration: "line-through", color: "darkgray" }}>{`${getPrice(item)}`}</span>
                                    {` ${PricingFunctions.getCurrencySymbol(countryCode)}${(Number(getNumericPrice(item)) * (1 - promoCodePercentage / 100)).toFixed(2)}`}
                                </>
                                : (getItemOwnedDiscount(item) || getItemCompanionDiscount(item)) ?
                                <>
                                    <span style={{ textDecoration: "line-through", color: "darkgray" }}>{getOriginalPrice(item)}</span>
                                    {` ${getPrice(item)}`}
                                </>
                                : getSaleStrikePrice(item) ?
                                <>
                                    {`${getPrice(item)}`}
                                    <span style={{ textDecoration: "line-through", color: "#c60d0d", fontSize: "0.8em", fontWeight: "normal", marginLeft: "0.5em" }}>{getSaleStrikePrice(item)}</span>
                                </>
                                :
                                (`${getPrice(item)}` || <DotLoader size="small" variant="dark" />)
                            }
                        </td>
                    </>
            }
        </tr>
    }

    return (
        <React.Fragment>
            <PageSEO {...SEO_CONFIG['/checkout']} />
            {/* Summer Sale banner at the top — only while the cart is empty. */}
            {items.length === 0 && <SummerSaleBannerSlot />}
            {showUpsell && 1 == 2 && <UpsellModal upsellItem={upsellItem} callback={upsellModalCallback}></UpsellModal>}
            <FormPage is="checkout">
                <Container>
                    <Row>
                        {
                            items.length === 0 ?
                                <React.Fragment>
                                    <div className={styles.checkoutForm}>
                                        <h1 className={styles.formTitle}>Your Cart Is Empty...</h1>
                                        <Link to='/shop' className={styles.button}>Go To Shop</Link>
                                    </div>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <div className={`${styles.checkoutForm}`}>
                                        {checkoutStep ?
                                            <h1 className={styles.formTitle}>{SEO_CONFIG['/checkout'].h1}</h1>
                                            :
                                            <h1 className={styles.formTitle}>Your Cart</h1>
                                        }
                                        {!checkoutStep &&
                                            <p><b>Games can be automatically added to your account<br />Or...you can choose to grab a digital voucher as a gift.</b></p>
                                        }
                                        {renderRewardsBox()}
                                        {renderCompanionDiscountBanner()}
                                        {
                                            promoCodeApplied && promoCodeMessage.length > 0 && discountCode != null &&
                                            <Alert variant={promoCodeApplied ? "success" : "danger"}>
                                                {promoCodeMessage}
                                            </Alert>
                                        }
                                        {renderItemList(items, "PRODUCT")}
                                        {
                                            !loadingCheckout && !checkoutStep && <div className={styles.couponSection}>
                                                {
                                                    !promoCodeApplied && <Form.Label className={styles.title}><br />Got a promo code?</Form.Label>
                                                }
                                                {
                                                    promoCodeApplied ?
                                                        <React.Fragment>
                                                            {/*<div>{promoCode}</div>*/}
                                                            {
                                                                promoCodeMessage.length > 0 && discountCode == null &&
                                                                <Alert variant={promoCodeApplied ? "success" : "danger"}>
                                                                    {promoCodeMessage}
                                                                </Alert>
                                                            }
                                                        </React.Fragment>
                                                        :
                                                        promoBoxOpen &&
                                                        <React.Fragment>
                                                            <Form.Control
                                                                className={styles.inp}
                                                                type="text"
                                                                autoComplete="off"
                                                                placeholder="Enter Promotion Code..."
                                                                required
                                                                onChange={onChangeCode}
                                                                value={promoCode} // <-- Bind value from state
                                                            />
                                                            {
                                                                promoCodeMessage.length > 0 &&
                                                                <Alert variant={promoCodeApplied ? "success" : "danger"}>
                                                                    {promoCodeMessage}
                                                                </Alert>
                                                            }
                                                            <button onClick={checkPromotionCode} className={`${styles.button} ${styles.alternate} ${styles.small}`} style={{ marginBottom: "10px", marginTop: "10px" }}>{checkingPromoCode ? <DotLoader size="medium" variant="light" /> : 'Get Discount'}</button>

                                                        </React.Fragment>
                                                }

                                            </div>
                                        }
                                        {
                                            !checkoutStep &&
                                            <>
                                                <Form onSubmit={checkAgeRestriction}>
                                                    <FloatingLabel className="mb-3" controlId="formBasicFirstName" label="First Name">
                                                        <Form.Control
                                                            disabled={loadingCheckout}
                                                            type="text"
                                                            placeholder="First Name"
                                                            onChange={onChangeFirstName}
                                                            value={firstName}
                                                            autoComplete="given-name"
                                                            aria-label="First Name">
                                                        </Form.Control>
                                                    </FloatingLabel>
                                                    <FloatingLabel className="mb-3" controlId="formBasicEmail" label="Email*">
                                                        <Form.Control
                                                            disabled={loadingCheckout}
                                                            type="email"
                                                            placeholder="Email*"
                                                            required
                                                            onChange={onChangeEmail}
                                                            value={email}
                                                            autoComplete="email"
                                                            aria-label="Email">
                                                        </Form.Control>
                                                    </FloatingLabel>
                                                    <Alert variant="warning" className="d-flex align-items-center gap-2 mb-3">
                                                        <span className={styles.infoIcon}>i</span>
                                                        Your receipt will be sent to the email address above.
                                                    </Alert>
                                                    <button className={`${styles.button} ${styles.wide}`} type="submit" id="submit" disabled={loadingCheckout}>{loadingCheckout ? <DotLoader size="medium" variant="light" /> : 'Checkout'}</button>
                                                </Form>
                                            </>
                                        }
                                    </div>
                                </React.Fragment>
                        }
                    </Row>
                    {
                        checkoutStep &&
                        <Row xs={12}>
                            {clientSecret ?
                                <Elements options={options} stripe={stripePromise}>
                                    <CheckoutForm email={email} clientSecret={clientSecret} />
                                </Elements>
                                :
                                <div className={`${styles.spinner}`} id="spinner"></div>
                            }
                        </Row>
                    }

                </Container>
            </FormPage>
            {
                !checkoutStep &&
                <section className={`${styles.band} ${styles.sm}`} style={{ backgroundColor: "#210f37" }}>
                    <Container>

                        <div className='row text-center justify-content-center'>
                            <h2 className='text-uppercase'>{items.length === 0 ? "Add Some Games" : "More Games You'll Love!"}</h2>
                            {getGameList().filter(g => g.status === "enabled" || isDev()).map(g => <div className='col-md-6 col-lg-4 text-center'><Game showAddToCart={true} game={g} key={g.gameId} /></div>)}

                            {/* {getGameList().filter(g => {g.gameId !== this.props.game.gameId }).map(g => <div className='col-md-6 col-lg-3 text-center'><Game game={g} key={g.gameId} /></div> )} */}

                            {/* {console.log(getGameList().filter(g => {g.gameId !== this.props.game.gameId }))} */}
                        </div>
                    </Container>
                </section>
            }
            <section className={styles.reviewsSection}>
                <div className="container">
                    <TrustBoxContainer
                        templateId={TRUSTPILOT_TEMPLATES.CAROUSEL}
                        height="240px"
                        width="100%"
                        theme="dark"
                        stars="4,5"
                    />
                </div>
            </section>
            {showAgeWarning && <ErrorModal
                title={"Age Restriction Warning"}
                styles={`${styles.screenModel} d-flex`}
                message={"One or more items in your cart are rated for adults and are unsuitable for children, please confirm you are 17+ years old?"}
                callback={cancelAgeWarning}
                callbackText={"Cancel"}
                callback2={acceptAgeWarning}
                callbackText2={"Confirm"}
            />}
            {checkoutError && <ErrorModal
                title={"Checkout Error"}
                styles={`${styles.screenModel} d-flex`}
                message={checkoutError}
                callback={dismissCheckoutError}
                callbackText={"OK"}
            />}

        </React.Fragment>
    );
}